import { useState } from 'react'
import promo from '../assets/promos/Modern Q&A Youtube Thumbnail_20241024_145110_0000.png'
import { FaTimes } from 'react-icons/fa'

const Promo = () => {
    const [showPromo, setShowPromo] = useState(true);
    return (
        showPromo &&
        <section className='max-w-screen-lg text-center my-10 mx-auto'>
            <div className='w-36 md:w-56 flex flex-col gap-2  fixed z-20 bottom-2 right-5'>
                <div className='flex justify-center'>
                    <FaTimes className='text-white text-xl cursor-pointer border-2 bg-black rounded ' onClick={()=>setShowPromo(false)} />
                </div>
                <img className='w-full' src={promo} alt="" />
                <button className='bg-secondary text-xs w-full cursor-pointer rounded text-white p-2'>
                    <a href="https://ko-fi.com/studiomercymusic" target='_blank' rel="noreferrer"> Support me on Ko-fi</a>
                </button>
            </div>
        </section>
    )
}

export default Promo